module.exports = __webpack_public_path__ + "img/sj.bc28d7e3.jpg";